import React from "react";
import PropTypes from "prop-types";
import Sidebar from "../components/layout/Sidebar";
import Header from "../components/layout/Header";
import StartGuide from "../components/layout/StartGuide";
import {ToastContainer} from "react-toastify";

import './Default.scss'

const DefaultLayout = ({ children, route }) => {
  return (
  <div className="wrap">
    <ToastContainer />
    <Sidebar route={route} />
    <div className="contents" route={route}>
      <Header route={route} />
      {children}
    </div>
    <StartGuide />
  </div>
)};

DefaultLayout.propTypes = {
  noNavbar: PropTypes.bool,
  noFooter: PropTypes.bool
};

DefaultLayout.defaultProps = {
  noNavbar: false,
  noFooter: true
};

export default DefaultLayout;
